import { Title } from 'components/Dashboard/Title'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RootState } from 'store'
import { DashboardCard, DCContent, DCTaskCount, Flex, P } from 'styling/GlobalStyles'
import { groputDashboardItems } from 'utils/helpers'
import { WidgetEditOverlay } from '../Dashboard.styled'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { IWidget } from 'types/dashboard.interface'
import { OtherText } from 'styling/Typography'

export const CyclesWidget = ({
  modalOpen,
  removeWidget,
  onDragStart,
  onDragOver,
  onDragDrop,
}: IWidget) => {
  const navigate = useNavigate()
  const { taskCycleStatuses } = useSelector((state: RootState) => state.dashboard)
  const cyclesData = groputDashboardItems(taskCycleStatuses)

  const getTaskStatus = (name: string): number => {
    return Number(cyclesData?.find((td) => td.name == name)?.value) || 0
  }

  return (
    <DashboardCard
      draggable={modalOpen}
      onDragStartCapture={() => {
        onDragStart('cycles', 1)
      }}
      onDrop={onDragDrop}
      onDragEnd={(e) => {
        e.preventDefault()
      }}
      onDragOver={(e) => {
        e.preventDefault()
        onDragOver('cycles')
      }}
      width='1fr'
      style={{ gridArea: 'cycles', cursor: modalOpen ? 'grab' : 'normal' }}
    >
      {modalOpen && (
        <WidgetEditOverlay
          onClick={(e) => {
            removeWidget('cycles')
            e.stopPropagation()
          }}
        >
          <P>Remove Widget</P>
          <CloseIcon white />
        </WidgetEditOverlay>
      )}
      <Title title='Cycles' arrow onClick={() => !modalOpen && navigate('/dashboard/cycles')} />
      <DCContent height='100%'>
        <Flex gap='1rem' width='100%'>
          <DCTaskCount flex>
            <OtherText>Not Started:</OtherText>
            <OtherText weight='bold'>{getTaskStatus('Not Started')}</OtherText>
          </DCTaskCount>
          <DCTaskCount flex>
            <OtherText>Completed:</OtherText>
            <OtherText weight='bold'>{getTaskStatus('Completed')}</OtherText>
          </DCTaskCount>
        </Flex>
        <Flex gap='1rem' width='100%'>
          <DCTaskCount flex>
            <OtherText>In Progress:</OtherText>
            <OtherText weight='bold'>{getTaskStatus('In Progress')}</OtherText>
          </DCTaskCount>
          <DCTaskCount flex>
            <OtherText>Idle:</OtherText>
            <OtherText weight='bold'>{getTaskStatus('Idle')}</OtherText>
          </DCTaskCount>
        </Flex>
        <Flex gap='1rem' width='100%'>
          <DCTaskCount flex>
            <OtherText>Paused:</OtherText>
            <OtherText weight='bold'>{getTaskStatus('Paused')}</OtherText>
          </DCTaskCount>

          <DCTaskCount width='100%' flex>
            <OtherText>Stopped:</OtherText>
            <OtherText weight='bold'>{getTaskStatus('Stopped')}</OtherText>
          </DCTaskCount>
        </Flex>
      </DCContent>
    </DashboardCard>
  )
}
